class Role {
  constructor({ id_role, role_name }) {
    this.id_role = id_role;
    this.role_name = role_name;
  }
}

export default Role;
